const IssueType = {
    InvalidStart: 'invalidStart',
    InvalidEnd: 'invalidEnd',
    NoValidWay: 'noValidWay',
    DeadEnd: 'deadEnd',
    NoIncomer: 'noIncomer',
    BadCycle: 'badCycle',
    NodeUnreachable: 'nodeUnreachable',
    LooseConstruct: 'looseConstruct',
    Redundancy: 'redundancy',
    noTitle: 'noTitle'
}

export default IssueType